<template>
    <div class="contact-floating">
        <div class="contact-container">
            <div class="contact-content"  @click="handleClick()">
                <img
                        class="contact-icon"
                        referrerpolicy="no-referrer"
                        src="../../assets/header/common_contact.png"
                />
                <span class="contact-text">
                    联系
                    <br />
                    我们
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactFloat',
        data() {
            return {
                hoverIndex: -1,
            };
        },
        methods: {
            handleClick() {
                this.$emit('change', 1); // 触发 change 事件
            }
        }

    }
</script>

<style scoped lang="css">
    .contact-floating {
        /* 固定定位实现悬浮效果 */
        position: fixed;
        right: 20px;
        bottom: 150px;
        z-index: 999;
    }

    .contact-container {
        box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.15);
        background-color: rgba(0, 134, 131, 1);
        border-radius: 28px;
        width: 56px;
        height: 96px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .contact-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 28px;
        height: 61px;
    }

    .contact-icon {
        width: 22px;
        height: 22px;
        margin-bottom: 7px;
    }

    .contact-text {
        width: 28px;
        height: 32px;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        line-height: 16px;
    }
    .contact-container {
        transition: transform 0.3s ease;
    }

    .contact-container:hover {
        transform: scale(1.05);
        cursor: pointer;
    }
</style>
